import styled from 'styled-components';

export const StepsListItemSC = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 24px;
  padding-right: 24px;

  &:not(:last-of-type) {
    border-bottom: 1px solid rgba(215, 217, 226, 0.7);
  }
  .summary {
    display: flex;
    align-items: center;
    &__date {
      color: #333d6c;
      font-weight: 600;
      font-size: 14px;
      margin-left: 10px;
    }
    &__progress {
      margin-left: -6px;
      display: flex;
      justify-content: center;
      position: relative;
      .count {
        position: absolute;
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
        font-size: 12px;
        font-weight: 700;
        &.empty {
          font-size: 9px;
          font-weight: 600;
        }
      }
      span {
        display: none;
      }
    }
  }

  .count {
    &__steps {
      color: #333d6c;
      font-weight: 800;
      font-size: 18px;
      line-height: 22px;
      text-align: right;
    }
    &__goal {
      color: rgba(51, 61, 108, 0.6);
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;
      text-align: right;
    }
  }
`;
